import { render, staticRenderFns } from "./sptcjy.vue?vue&type=template&id=042d0029&scoped=true&"
import script from "./sptcjy.vue?vue&type=script&lang=js&"
export * from "./sptcjy.vue?vue&type=script&lang=js&"
import style0 from "./sptcjy.vue?vue&type=style&index=0&id=042d0029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d0029",
  null
  
)

export default component.exports